// Currency + date helpers (Indian formatting)

export function formatINR(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2).replace(/\.00$/, "")} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(2).replace(/\.00$/, "")} L`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export function banksLabel(banks) {
  if (!banks) return "—";
  if (Array.isArray(banks)) return banks.join(", ") || "—";
  return String(banks);
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return String(d);
  }
}

export function daysSince(d) {
  if (!d) return null;
  const diff = Date.now() - new Date(d).getTime();
  return Math.floor(diff / 86400000);
}

export function plural(n, one, many) {
  return `${n} ${n === 1 ? one : (many || one + "s")}`;
}

export function fmtLastConv(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return String(d);
  const base = dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const that = new Date(dt); that.setHours(0, 0, 0, 0);
  const diff = Math.round((today - that) / 86400000);
  const rel = diff <= 0 ? "today" : diff === 1 ? "yesterday" : `${plural(diff, "day")} ago`;
  return `${base} · ${rel}`;
}

export function fmtDateTimeIST(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Kolkata",
    });
  } catch {
    return String(d);
  }
}

export function isOverdue(followUp) {
  if (!followUp) return false;
  const d = new Date(followUp);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
}
